<template>
    <jet-action-section :working="form.processing">
        <template #title>
            Smazat účet
        </template>

        <template #description>
            Permanentně smazat účet.
        </template>

        <template #content>
            <div class="max-w-xl text-sm text-gray-600">
                Smazáním vašeho účtu dojde k odstranení všech přístupových údajů, zpráv a jiných dat spojených s tímto účtem. Před smazáním se ujistěte, že v DSchránce nejsou žádná nezálohovaná data, která chcete zachovat.
            </div>

            <div class="mt-5">
                <jet-danger-button @click.native="confirmUserDeletion">
                    Smazat účet
                </jet-danger-button>
            </div>

            <!-- Delete Account Confirmation Modal -->
            <jet-dialog-modal :show="confirmingUserDeletion" @close="closeModal">
                <template #title>
                    Smazat účet
                </template>


                <template #icon>
                    <svg class="h-6 w-6 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </template>

                <template #content>
                    Určitě si přejete smazat tento účet? Smazáním vašeho účtu dojde k odstranení všech přístupových údajů, zpráv a jiných dat spojených s tímto účtem. Před smazáním se ujistěte, že v DSchránce nejsou žádná nezálohovaná data, která chcete zachovat. Pro potvrzení zadejte své heslo.

                    <div class="mt-4">
                        <jet-input type="password" class="mt-1 block w-full" placeholder="Heslo"
                                    ref="password"
                                    v-model="form.password"
                                    @keyup.enter.native="deleteUser" />

                        <jet-input-error :message="form.errors.password" class="mt-2" />
                    </div>
                </template>

                <template #footer>
                    <jet-danger-button @click.native="deleteUser" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Smazat účet
                    </jet-danger-button>
                    <jet-secondary-button class="mx-2" @click.native="closeModal">
                        Zrušit
                    </jet-secondary-button>
                </template>
            </jet-dialog-modal>
        </template>
    </jet-action-section>
</template>

<script>
    import JetActionSection from '@/Jetstream/ActionSection'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import JetDangerButton from '@/Jetstream/DangerButton'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton'

    export default {
        components: {
            JetActionSection,
            JetDangerButton,
            JetDialogModal,
            JetInput,
            JetInputError,
            JetSecondaryButton,
        },

        data() {
            return {
                confirmingUserDeletion: false,

                form: this.$inertia.form({
                    password: '',
                })
            }
        },

        methods: {
            confirmUserDeletion() {
                this.confirmingUserDeletion = true;

                setTimeout(() => this.$refs.password.focus(), 250)
            },

            deleteUser() {
                this.form.delete(route('current-user.destroy'), {
                    preserveScroll: true,
                    onSuccess: () => this.closeModal(),
                    onError: () => this.$refs.password.focus(),
                    onFinish: () => this.form.reset(),
                })
            },

            closeModal() {
                this.confirmingUserDeletion = false

                this.form.reset()
            },
        },
    }
</script>
